
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { PipelineStage, Prospect } from '@/types/pipeline';
import { PLACEHOLDER_PIPELINE } from '@/hooks/placeholder-data';
import { toast } from '@/hooks/errors/use-toast';

export const usePipelineData = () => {
  return useQuery({
    queryKey: ['pipeline-data'],
    queryFn: () => {
      // Return placeholder pipeline data
      return PLACEHOLDER_PIPELINE;
    },
    staleTime: 30000 // 30 seconds
  });
};

export const useUpdateProspectStatus = () => {
  const queryClient = useQueryClient();

  const updateMutation = useMutation({
    mutationFn: async ({ 
      id, 
      newStatus 
    }: { 
      id: string; 
      newStatus: PipelineStage 
    }) => {
      console.log(`[UPDATE STATUS] Updating prospect ${id} to status ${newStatus}`);
      
      // In the prototype, we'll just log the update and pretend it worked
      // No actual database update happens
      return true;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['pipeline-data'] });
    },
    onError: (error) => {
      console.error('[UPDATE STATUS] Error:', error);
      toast({
        title: "Update failed",
        description: "Could not update the pipeline status. Please try again.",
        variant: "error",
      });
    }
  });

  // Expose a function that matches the expected signature
  const updateStatus = (data: { id: string; newStatus: PipelineStage }) => {
    return updateMutation.mutateAsync(data);
  };
  
  return { updateStatus, isUpdating: updateMutation.isPending };
};
